// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, OnInit, OnDestroy, AfterViewInit, Input, TemplateRef, ViewChild, Output, EventEmitter, HostBinding } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatSnackBar, MatDialog } from '@angular/material';
import { fadeInOut } from '../../services/animations';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { AuditLogin } from 'src/app/models/auditLogin.model';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'auditLogin',
  templateUrl: './auditLogin.component.html',
  styleUrls: ['./auditLogin.component.scss'],
    animations: [fadeInOut]
})

export class AuditLoginComponent
{
  private isSaving: boolean;
  private isNew: boolean;
  auditLogin: AuditLogin;

  userName: string = '';
  initialDate: Date = new Date();
  finalDate: Date = new Date();
  displayedColumns = ['userName', 'status', 'data'];
  isDataLoaded: boolean = false;
  loadingIndicator: boolean = true;
  formResetToggle: boolean = true;
  selectDepedentProduct: boolean = false;
  _currentUserId: string;
  listAuditLogin: AuditLogin[];
  dataSourceAuditLogin: MatTableDataSource<AuditLogin>;
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  afiseazaDate() {
    this.loadingIndicator = true;

    let userName = this.userName == null || this.userName == "" ? "undefined" : this.userName;
    let dateStart = this.initialDate == null ? 'undefined' : this.config.formatOnlyDate(this.initialDate, '.');
    let dateFinal = this.finalDate == null ? 'undefined' : this.config.formatOnlyDate(this.finalDate, '.');
    
    this.accountService
      .getAuditLoginList(userName, dateStart, dateFinal)
      .subscribe(results => {

        let linii = results[0];
        let liniiReconverted = JSON.parse(JSON.stringify(linii));
        this.listAuditLogin = liniiReconverted;
        this.dataSourceAuditLogin.data = this.listAuditLogin;

        this.isDataLoaded = true;

        setTimeout(() => { this.loadingIndicator = false; }, 1500);

        this.dataSourceAuditLogin.paginator = this.paginator;
        this.dataSourceAuditLogin.sort = this.sort;
      },
        error => {
        });

  }
  
  ngAfterViewInit() {
    this.dataSourceAuditLogin.paginator = this.paginator;
    this.dataSourceAuditLogin.sort = this.sort;
  }

  reset() {
    this.userName = '';
    this.initialDate = new Date();
    this.initialDate.setDate(new Date().getDate() - 7);
    this.finalDate = new Date();
    this.afiseazaDate();
  }
  
  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    public config: ConfigurationService,
  )
  {
    this.dataSourceAuditLogin = new MatTableDataSource<AuditLogin>();
  }

  ngOnInit() {
    this.initialDate = new Date();
    this.initialDate.setDate(new Date().getDate() - 7);
    this.finalDate = new Date();
    this.afiseazaDate();
  }
  
}
